import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
	static targets = [
		"select",
		"table",
		"slider",
		"voyageFrom",
		"voyageTo",
		"labelFrom",
		"labelTo"
	]

	connect() {
		this.setupSlider()
	}

	setupSlider() {
		if (!this.hasTableTarget) return
		const urlParams = new URLSearchParams(window.location.search)
		if (urlParams.get("forward") === "true") return

		const system = this.tableTarget.dataset.system
		let startDate = (system === "bulk")
				? new Date(Date.UTC(2023, 7, 1, 0, 0, 0)) // August 1, 2023
				: new Date(Date.UTC(2020, 0, 1, 0, 0, 0)) // Jan 1, 2020

		const now = new Date()
		const endDate = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()))
		const diffDays = Math.ceil(Math.abs(endDate - startDate) / (1000 * 3600 * 24))
		this.startSlider(startDate, endDate, diffDays)
	}

	startSlider(startDate, endDate, diffDays) {
		const addDays = (date, days) => {
			let result = new Date(Date.UTC(
					date.getUTCFullYear(),
					date.getUTCMonth(),
					date.getUTCDate()
			))
			result.setDate(result.getUTCDate() + days)
			result.setUTCHours(0, 0, 0, 0)
			return result
		}

		const formatDate = (date) => {
			return `${date.getUTCFullYear()}-${date.getUTCMonth() + 1}-${date.getUTCDate()}`
		}

		const slider = $(this.sliderTarget).slider({
			range: true,
			min: 0,
			max: diffDays,
			step: 1,
			values: [diffDays, diffDays],
			animate: true,
			slide: (event, ui) => {
				const fromDate = addDays(startDate, parseInt(ui.values[0]))
				const toDate = addDays(startDate, parseInt(ui.values[1]))

				this.voyageFromTarget.value = fromDate.toISOString()
				this.voyageToTarget.value = toDate.toISOString()

				this.labelFromTarget.textContent = formatDate(fromDate)
				this.labelToTarget.textContent = formatDate(toDate)
			}
		})

		// Set initial values
		const initialFrom = addDays(startDate, slider.slider("values")[0])
		const initialTo = addDays(startDate, slider.slider("values")[1])

		this.voyageFromTarget.value = initialFrom.toISOString()
		this.voyageToTarget.value = initialTo.toISOString()

		this.labelFromTarget.textContent = formatDate(startDate)
		this.labelToTarget.textContent = formatDate(endDate)
	}

	changeGhgYear() {
		const selectedYear = this.selectTarget.value
		document.getElementById('loading-screen').classList.remove('d-none')

		const url = new URL(window.location.href)
		url.searchParams.set("ghg_year", selectedYear)
		window.location.href = url.toString()
	}
}